import { renderCommonMap } from '../render';
import { IEnum } from './interface';

export function getRenderFun(render: string | Function, enumMap?: IEnum) {
  const renderFun = typeof render === 'function' ? render : renderCommonMap[render];

  if (!renderFun && !enumMap) {
    return ({ row, col }: any) => row[col.colKey];
  }
  return ({ row, col }: { row: any; col: any }) => {
    if (enumMap && !renderFun) {
      return enumMap[row[col.colKey]];
    }
    return renderFun(row[col.colKey], row, enumMap);
  };
}
